import ArrowIcon from "@icons/arrowIcon.svg";
import { useTranslation } from "next-i18next";
import styles from "./lectureVideoItem.module.scss";
import Link from "next/link";

export const LectureVideoItem = (props: Props) => {
  const { t } = useTranslation("questionIndexing");

  return (
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <span>{props.index}.</span>
        <Link className={styles.title} href={props.slug}>
          {props.title}
        </Link>
      </div>
      <div className={styles.description}>{props.description}</div>
      <div className={styles.goLink}>
        {t("question_indexing_learning_contents_cta")}
        <ArrowIcon />
      </div>
    </div>
  );
};

interface Props {
  index: number;
  title: string;
  description: string;
  slug: string;
}
